import "./StorageImages.css";

const StorageImages = ({
  storagePhotos,
  setDeletePhoto,
  setThumbnailPhoto,
  thumbnailPhoto,
}) => {
  const handleSetDeletePhoto = (idx) => {
    setDeletePhoto(idx);
  };

  return (
    <div>
      <h4>Slike iz baze</h4>
      <div className="storageImagesContainer">
        {storagePhotos.map((photo, idx) => {
          const encodedImagePath = encodeURIComponent(photo);
          const isThumbnail =
            thumbnailPhoto?.type === "existing" && thumbnailPhoto.url === photo;

          return (
            <div className="storagePhotoContainer" key={photo}>
              <img
                className="thumbnail"
                src={`https://api.admin.meetserbia.rs/images/${encodedImagePath}`}
                alt="small thumbnail"
              />

              {isThumbnail ? (
                <span className="thumbnailBadge">Naslovna</span>
              ) : (
                <button
                  type="button"
                  className="thumbnailBtn"
                  onClick={() => setThumbnailPhoto(photo)}
                >
                  Za naslovnu
                </button>
              )}

              <span
                className="removeBtn"
                onClick={() => handleSetDeletePhoto(idx)}
              >
                x
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StorageImages;
